var map = {
	"./allen.png": 26,
	"./bell.png": 27,
	"./collab-background.png": 28,
	"./crowder.png": 20,
	"./ford.png": 21,
	"./hart.png": 29,
	"./history-background.png": 30,
	"./holmes.png": 31,
	"./jefferson.png": 32,
	"./mason.png": 33,
	"./roberts.png": 34,
	"./russo.png": 35,
	"./stanton.png": 36
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;